import { useMemo } from "react";
import { useEntityByName } from "./use-entity-by-name";
import { useEntitiesFromDb } from "./use-entities-from-db";
import { useCustomerConfig } from "../use-customer-config";
import { buildEntityFormSchemas } from "@/services/entity-form-schema";
import type { Entity } from "@/services/entity.service";

export const useEntitySchemaByName = (entityName: string) => {
  const { entity } = useEntityByName(entityName);
  const { allAvailableEntities } = useEntitiesFromDb();
  const { localeFieldId } = useCustomerConfig();

  // Name → entity lookup so relation fields can resolve their target's fields.
  const entitiesByName = useMemo(() => {
    const map = new Map<string, Entity>();
    (allAvailableEntities ?? []).forEach((e) => {
      if (e) map.set(e.name, e);
    });
    return map;
  }, [allAvailableEntities]);

  return useMemo(
    () => buildEntityFormSchemas(entity, (name) => entitiesByName.get(name), localeFieldId),
    [entity, entitiesByName, localeFieldId],
  );
};
